<template>
    <div class="userManage contentBack">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>服务咨询 </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="titleH2">

            服务咨询
        </div>
        <!-- 搜索用户 -->
        <!-- <div style="display: flex; margin-left: 20px; margin-top: 17px">
      <el-input
        id="input1"
        v-model="unameInput"
        placeholder="请输入联系电话/账号/姓名"
      ></el-input
      ><el-button id="btn1" type="primary" @click="searchByName"
        >搜 索</el-button
      >
    </div> -->
        <!-- 用户列表 -->
        <div id="userLIst">
            <!-- <div class="listTitle">用户列表</div>
      <div id="addOrdeleteUser">
        <el-button size="small" @click="addUser"
          ><i
            class="el-icon-circle-plus-outline"
            style="color: #47a909; font-size: 14px; margin-right: 5px"
          ></i
          >添加用户</el-button
        >
        <el-button size="small" @click="deleteUsers"
          ><i
            class="el-icon-remove-outline"
            style="color: #d5146d; font-size: 14px; margin-right: 5px"
          ></i
          >删除用户</el-button
        >
      </div> -->
            <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" border max-height="60vh" :data="tableData">
                <!-- 选择框 -->
                <!-- <el-table-column :resizable="false" type="selection" width="40"></el-table-column> -->
                <!-- 序号 -->
                <el-table-column :resizable="false" label="序号" width="50" type="index">
                </el-table-column>
                <el-table-column :resizable="false" prop="contacts" label="联系人"></el-table-column>
                <el-table-column :resizable="false" prop="phone" label="联系电话"></el-table-column>
                <el-table-column :resizable="false" prop="createTime" label="留言日期">
                </el-table-column>
                <el-table-column :resizable="false" prop="title" label="留言标题">
                </el-table-column>
                <el-table-column :resizable="false" prop="content" label="留言内容">
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="page-pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 15, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                :total="userNums">
            </el-pagination>
            <el-button size="mini" type="primary" style="margin-left: 5px">确定</el-button>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageSize: 10,
            pageNum: 1,
            currentPage: 1,
            userNums: 0,
            tableData:[]
        }
    },
    mounted(){
        this.initTable()
    },  
    methods: {
        initTable(){
            this.$post(`/consult/getMessageBoardList?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(res=>{
                this.userNums = res.data.total;
                this.tableData = res.data.list
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initTable()

        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.initTable()
        },
    }
}
</script>